import { useState } from "react";
import {
  trackPinSessionEscapeHatchClicked,
  trackPinSessionEscapeHatchConfirmed,
  trackPinSessionEscapeHatchDismissed
} from "../transfersPinningAnalytics";

const TRIGGER_TYPE = "transfers";

type Pin = {
  id: string;
  isNew?: boolean;
  messages?: unknown[];
};

type PinningPanel = {
  activePin: () => Pin | null;
  pins: Pin[];
};

type EscapeHatchOptions = {
  onConfirm: () => void;
};

type EscapeHatchReturn = {
  escapeHatchModalOpen: boolean;
  handleEscapeHatchClick: () => void;
  handleEscapeHatchConfirm: () => void;
  handleEscapeHatchDismiss: () => void;
};

export function useEscapeHatch(
  panel: PinningPanel,
  { onConfirm }: EscapeHatchOptions
): EscapeHatchReturn {
  const [escapeHatchModalOpen, setEscapeHatchModalOpen] = useState(false);

  function buildEventPayload() {
    return {
      triggerType: TRIGGER_TYPE,
      pinCount: panel.pins.length,
      messageCount: panel.activePin()?.messages?.length ?? 0
    };
  }

  function handleEscapeHatchClick() {
    trackPinSessionEscapeHatchClicked(buildEventPayload());
    setEscapeHatchModalOpen(true);
  }

  function handleEscapeHatchConfirm() {
    trackPinSessionEscapeHatchConfirmed(buildEventPayload());
    setEscapeHatchModalOpen(false);
    onConfirm();
  }

  function handleEscapeHatchDismiss() {
    trackPinSessionEscapeHatchDismissed(buildEventPayload());
    setEscapeHatchModalOpen(false);
  }

  return {
    escapeHatchModalOpen,
    handleEscapeHatchClick,
    handleEscapeHatchConfirm,
    handleEscapeHatchDismiss
  };
}
